import React from 'react';
import posts from '../../Hero/heroPosts/postData';
import clock from '../../../assets/images/techIcons/clock.png';
import classes from './recentPost.module.css';

const RecentPost = () => {
  // Get the 3 most recent posts (you can adjust this number)
  const recentPosts = posts.slice(0, 3);

  return (
    <div className={classes.recentPostSection}>
      <p className={classes.recentPostHeading}>RECENT POSTS..</p>
      {recentPosts.map((post) => (
        <div key={post.id} className={classes.recentPostContainer}>
          <div className={classes.postImgContainer}>
            <img src={post.imageUrl} alt={post.title} />
          </div>
          <div className={classes.RecentPostContent}>
            <div className={classes.RecentPostTitle}>{post.title}</div>
            <div className={classes.recentPostTime}>
              <img src={clock} alt="clock" />
              <p>{post.dateRecent}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentPost;